// 標準のスナックバー表示期間
export const defaultDuration = 3000;
